import { render, staticRenderFns } from "./CreateApplication.vue?vue&type=template&id=d53c8016&scoped=true"
import script from "./CreateApplication.vue?vue&type=script&lang=js"
export * from "./CreateApplication.vue?vue&type=script&lang=js"
import style0 from "./CreateApplication.vue?vue&type=style&index=0&id=d53c8016&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53c8016",
  null
  
)

export default component.exports